import React, { useContext } from 'react';
import { LineChart } from '../../../LineChart';
import { ChartLinePoint } from '../../../LineChart/LineChart.controller';
import { AnalyticsContext } from '../../../AnalyticsProvider';
import { AnalyticsVisualizationType } from '../../AnalyticsDashboard.controller';
import { ConfigChartTicks } from 'modules/Analyze/helpers/chartHelpers';

type AudienceGrowthChartViewProps = {
  dates: Date[];
  profileIds: string[];
  hideSomeGridLines?: boolean;
  loading: boolean;
  isEmpty?: boolean;
  ticksConfig?: ConfigChartTicks;
  firstDateFromData: string;
  lastDateFromData: string;
  getValuesForChartCb?: () => ChartLinePoint[][];
  initialFollowers: { [key: string]: number | null };
};

export const AudienceGrowthChartView = ({
  loading,
  isEmpty,
  ticksConfig,
  profileIds,
  firstDateFromData,
  lastDateFromData,
  getValuesForChartCb,
  initialFollowers,
  dates
}: AudienceGrowthChartViewProps) => {
  const { view } = useContext(AnalyticsContext);
  return (
    <LineChart
      chartTitle={'Audience Growth'}
      chartSubTitle={view === AnalyticsVisualizationType.overview ? 'Per profile, by day' : 'By day'}
      subTitleTooltipText={'See how much your follower count has grown since the start of the date range, e.g. +100% growth indicates your follower count has doubled. Hover over the chart to see actual values.'}
      dates={dates}
      loading={loading}
      isEmpty={isEmpty}
      ticksConfig={ticksConfig}
      profileIds={profileIds}
      firstDateFromData={firstDateFromData}
      lastDateFromData={lastDateFromData}
      initialFollowers={initialFollowers}
      getValuesForChartCb={getValuesForChartCb}
      valueKeyString={'rawValue'}
      valueKeyStringForAxisY={view === AnalyticsVisualizationType.overview ? 'normalizedValue' : 'rawValue'}
      shouldNormalize={view === AnalyticsVisualizationType.overview}
      isEngagementChart={false}
    />
  );
};
